// extracted by mini-css-extract-plugin
export var dividerLine = "_5b-0";
export var errorBackground = "_5b-1";